"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __importDefault(require("swr/immutable"));
var sanity_query_1 = require("@aonawale/sanity-query");
/**
 * A hook that fetches data from Sanity.
 * @param client - The Sanity client.
 * @param query - The query to fetch data with.
 * @param projection - The projection to fetch data with.
 * @returns The query response.
 * @example
 * const client = sanityClient({...})
 * const query = {
 *  constraints: [
 *   filter('name', 'match', 'John'),
 *   order('age', 'asc'),
 *   slice(0, 10),
 *  ],
 * }
 * const projection = '_id, name, age'
 * const {data, error, isLoading} = useQuery(client, query, projection)
 * console.log(data, error, isLoading)
 * => [{_id: '...', name: 'John', age: 42}, ...], undefined, false
 */
var useQuery = function (client, query, projection) {
    var parts = query ? [(0, sanity_query_1.buildQuery)(query)] : [];
    if (query && projection)
        parts.push("{".concat(projection, "}"));
    var queryString = parts.length ? parts.join(' ') : undefined;
    var response = (0, immutable_1.default)(queryString, function () { return client.fetch(queryString || ''); });
    return { data: response.data, error: response.error, isLoading: response.isLoading };
};
exports.default = useQuery;
//# sourceMappingURL=use-query.js.map